import React from 'react'
import type { ObjectLike } from '@skedulo/horizon-types'
import { useTemplate } from '../hooks'

export interface ITemplateByNameProps {
  name: string
  context?: ObjectLike
}

export const TemplateByName: React.FC<ITemplateByNameProps> = ({
  name,
  context,
}) => {
  const { result } = useTemplate({ templateName: name, context })

  return <>{result}</>
}
